import Vue from 'vue';
import VueRouter from 'vue-router';
import baseRouterList from './baseRouterList';
import mainRouterList from './mainRouterList';

Vue.use(VueRouter);

const routes = [
  ...baseRouterList,
  ...mainRouterList,
  {
    path: '*',
    name: 'exception404',
    component: () => import('@/views/exception/exception404.vue'),
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition)
      return savedPosition;
    else
      return { x: 0, y: 0 }
  }
});

export default router;
